'use strict';
import Vue from 'vue';
import * as types from './../mutation-types';

const state = {
    data: {},
    webp: false,
    assetsIsLoading: false,
    youtubeApiLoaded: false,
    previewSizes: [240, 480, 640, 1024, 1280, 2048],
};

const getters = {
    youtubeApiLoaded: state => {
        return state.youtubeApiLoaded;
    },
    all: state => {
        return state;
    },
    settings: state => {
        return state.data;
    },
    thumbsWebpSupport: state => {
        return state.data.thumbsWebpSupport;
    },
    webp: state => {
        return state.webp;
    },
    previewSizes: state => {
        return state.previewSizes;
    },
    thumbnailsUrl: state => {
        return state.data.thumbnailsUrl;
    },
};

const actions = {};

const mutations = {
    [types.RECEIVE_SETTINGS](state, val) {
        Vue.set(state, 'data', val);
    },
    webp(state, val) {
        state.webp = val;
    },
    assetsIsLoading(state, val) {
        state.assetsIsLoading = val;
    },
    youtubeApiLoaded(state, val) {
        state.youtubeApiLoaded = val;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
